import { CREATE_FAQ, SHOW_FAQ, UPDATE_FAQ } from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  data: {
    id: "",
    question: "",
    answer: "",
    is_active: 0,
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_FAQ.REQUEST:
    case UPDATE_FAQ.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
      };

    case SHOW_FAQ.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
      };

    case CREATE_FAQ.SUCCESS:
      return {
        ...state,
        success_msg: "create_success",
        loading: false,
      };

    case UPDATE_FAQ.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case SHOW_FAQ.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data.data,
        },
        loading: false,
      };

    case CREATE_FAQ.FAILURE:
    case SHOW_FAQ.FAILURE:
    case UPDATE_FAQ.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
      };

    default:
      return state;
  }
};
